module.exports = __webpack_public_path__ + "static/media/park1.bd1d42e8.png";